import { DatabaseRecord } from "../repos/table.repo";

export interface SampleTestModel extends DatabaseRecord {
    name: string;
    sendDate?: Date;
    receiverResultDate?: Date;
    status: string;
    waterFactoryId: string;
}

export class SampleTestModelFactory {
    static getEmpty(): SampleTestModel {
        return {
            id: "",
            name: "",
            sendDate: new Date(),
            receiverResultDate: new Date(),
            status: "",
            waterFactoryId: ""
        };
    }
}